import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';

const SweetAlertOptions = {
    confirmButtonColor: '#41B882',
    cancelButtonColor: '#FF7674',
};

Vue.use(VueSweetalert2);

export default {
    methods: {
        mensaje: function (tipo, titulo, mensaje) {
            this.$swal.fire({
                icon: tipo,
                title: titulo,
                text: mensaje,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Aceptar',
                showCloseButton: true,
                showConfirmButton: true,
                backdrop: true,
            });
        },
        mensajeConfirm: function (texto, titulo) {
            return this.$swal.fire({
                icon: 'question',
                title: titulo,
                text: texto,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Aceptar',
                showCloseButton: true,
                showConfirmButton: true,
                showCancelButton: true,
                backdrop: true,
            });
        },
        mensajeError: function (error) {
            let mensajes = [];

            if (error.errors) {
                mensajes.push('Disculpe, verifique los datos ingresados.');
            }

            if (error.msg) {
                mensajes.push(error.msg);
            }

            if (error.message) {
                mensajes.push(`ERROR: ${error.message}`);
            }

            return this.$swal.fire({
                icon: 'error',
                html: mensajes.join('<br>'),
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Aceptar',
                showCloseButton: true,
                showConfirmButton: true,
                backdrop: true,
            });
        }
    }
};
